/* eslint-disable @typescript-eslint/naming-convention */
import type { Menu, Reference } from '@ps/web-martech-cms-types';
import React from 'react';

import SubmenuItem from '../SubmenuItem/SubmenuItem';

import styles from './SubmenuChildren.scss';

interface Props {
  parentUrl?: string;
  parentPageRef?: Reference[];
  menuItems: Menu[];
  onClick?(): void;
}

const SubmenuChildren: React.FC<Props> = ({ menuItems, parentUrl, parentPageRef, onClick }) => (
  <ul className={styles.submenuChildren}>
    {menuItems.map(({ heading, url, uid, page, resolver_tag: resolverTag }, index) => {
      const itemLimit = menuItems.length;

      return (
        index <= itemLimit && (
          <li key={uid} className={styles.item}>
            <SubmenuItem
              pageRef={itemLimit === index ? parentPageRef : page}
              url={itemLimit === index ? parentUrl : url}
              heading={heading}
              resolverTag={resolverTag}
              onClick={onClick}
            />
          </li>
        )
      );
    })}
  </ul>
);

export default SubmenuChildren;
